import { Stack, Typography } from '@mui/material';

export default function PageHeader({ text, variant }) {

    return (
        <Stack spacing={2} padding={2} margin={2} textAlign='center'>
            <Typography variant={variant}>{text}</Typography>
        </Stack>
    );
}